export const zh = {
    // App branding
    'app.name': '考完即弃',
    'app.nameEn': 'Cram & Toss',
    'app.tagline': '考前生成、考完即弃',
    // Common
    'common.settings': '设置',
    'common.close': '关闭',
    'common.unknownError': '未知错误',
    'common.cancel': '取消',
    'common.confirm': '确认',
    'common.save': '保存',
    'common.next': '下一步',
    'common.previous': '上一步',
    'common.back': '返回',
    'common.continue': '继续',
    'common.finish': '完成',
    'common.delete': '删除',
    'common.loading': '加载中…',
    'common.error': '出错了',
    'common.retry': '重试',
    // Settings
    'settings.title': '设置',
    'settings.language': '界面语言',
    'settings.languageHint': '切换后立即生效；偏好保存在本地。',
    'settings.theme': '主题',
    'settings.themeLight': '浅色',
    'settings.themeDark': '深色',
    'settings.themeAuto': '跟随系统',
    // Nav
    'nav.dashboard': '总览',
    'nav.flashcards': '闪卡',
    'nav.quiz': '选择题',
    'nav.drill': '刷题',
    'drill.title': '刷题',
    'drill.subtitle': '挑题型 × 选范围 × 开练。',
    'drill.kindLabel': '题型',
    'drill.scopeLabel': '范围',
    'drill.scopeAll': '全部章节',
    'drill.start': '开始 →',
    'drill.empty': '本课暂无可练题型',
    'drill.emptyHint': '请先生成或导入课程内容；之后这里会列出可练的题型。',
    'nav.mindmap': '思维导图',
    'nav.glossary': '词汇表',
    'nav.lectureNotes': '讲义',
    'nav.essay': 'Essay 练习',
    'nav.wrongAnswers': '错题本',
    'nav.mockExam': '模拟考试',
    'nav.mockCenter': 'Mock 中心',
    'nav.guide': '使用指引',
    'guide.backHome': '返回首页',
    'guide.linkText': '使用指引',
    'nav.proofDrill': '证明推导',
    'nav.freeResponse': '自由作答',
    'nav.readingPassage': '阅读理解',
    'nav.bookmarks': '收藏',
    'nav.examModeGroup': '考场模式',
    'nav.manageGroup': '管理',
    'nav.settings': '课程设置',
    'nav.outline': '大纲',
    'outline.title': '课程大纲',
    'outline.empty': '暂无大纲数据',
    'outline.emptyHint': '大纲在内容生成时创建。首次生成后将在此显示。',
    'outline.chapter': '章节',
    'outline.concepts': '概念',
    'outline.topics': '主题',
    'outline.items': '题',
    'outline.noOutline': '大纲尚未生成',
    'outline.noOutlineHint': '请先生成内容——课程大纲将在此呈现。',
    'outline.confirmedHint': '你确认过的课程大纲，生成内容基于此结构。',
    'outline.source': '来源',
    'outline.sourceUser': '用户手录',
    'outline.sourceLLM': 'LLM 生成',
    'outline.regenRunning': '正在生成内容…',
    'nav.history': '历史',
    'history.title': '生成历史',
    'history.empty': '暂无生成历史',
    'history.emptyHint': '首次内容生成后，结果将在此展示。',
    'history.loadingDetail': '正在读取生成历史…',
    'history.course': '课程',
    'history.generatedAt': '生成时间',
    'history.items': '题',
    'history.tokens': 'token',
    'history.duration': '耗时',
    'history.quality': '质量',
    'history.errors': '错误',
    'history.warns': '警告',
    'history.noResults': '暂无结果',
    'history.noResultsHint': '为课程生成内容后即可在此查看。',
    'history.viewCourse': '查看课程',
    'history.gapReport': '审计报告',
    'onboard.welcome': '欢迎使用 ExamForge',
    'onboard.welcomeSub': '你的考试备考学习伙伴',
    'onboard.step1Title': '创建课程',
    'onboard.step1Text': '输入课程名称，上传源 PDF，配置你想要生成的学习内容。',
    'onboard.step2Title': '生成内容',
    'onboard.step2Text': 'AI 阅读你的材料，生成选择题、闪卡、论述题等——所有内容可追溯至原始材料。',
    'onboard.step3Title': '专注学习',
    'onboard.step3Text': '按章节刷题，用间隔重复追踪薄弱点，限时模拟考试。',
    'onboard.step4Title': '精调与迭代',
    'onboard.step4Text': '查看课程大纲，检查审计报告，按需生成本章内容。',
    'onboard.next': '下一步',
    'onboard.skip': '跳过',
    'onboard.done': '知道了',
    'onboard.start': '创建你的第一个课程',
    'nav.regen': '内容生成',
    'refine.mode': '模式',
    'refine.modeReplace': '替换 — 覆盖已有题目',
    'refine.modeAdd': '追加 — 添加新题目',
    'refine.addCount': '新增数量',
    'refine.hint': '自定义提示',
    'refine.hintPlaceholder': '例：「聚焦第三章框架分析」',
    'refine.running': '正在生成… {stage}（已完成 {done} 阶段）',
    'refine.done': '生成完成 — {tokens} token，耗时 {duration}',
    'refine.failed': '生成失败：{error}',
    'refine.noSources': '无源文件',
    'refine.noSourcesHint': '请先上传源文件以启用内容生成功能。',
    'diff.title': '变更对比',
    'diff.before': '变更前',
    'diff.after': '变更后',
    'diff.noChange': '未检测到变更',
    'diff.close': '关闭',
    'diff.field': '字段',
    'diff.added': '新增',
    'diff.removed': '删除',
    'courseSettings.heading': '课程设置',
    'courseSettings.subtitle': '编辑配置 · 生成内容 · 清空 · 导入导出 · 删除',
    'courseSettings.basicsHeading': '基本信息',
    'courseSettings.contentHeading': '内容操作',
    'courseSettings.contentHint': '导入的是「课程配置」文件（不是已生成的题库内容）。导入会替换当前配置，但你的练习进度保留。',
    'courseSettings.dangerHeading': '危险操作',
    'courseSettings.dangerHint': '清空进度只清错题/SRS/练习记录；删除课程会移除所有数据（配置 + 内容 + 进度 + 上传的 PDF）。',
    'courseSettings.regenerate': '生成内容',
    // TECH_DEBT §14: LLM API 统一注册待做（代号引用留在注释，不进 UI）
    'courseSettings.regenerateDisabledTooltip': '内容生成功能即将开放',
    'courseSettings.exportConfig': '导出配置',
    'courseSettings.importConfig': '导入配置',
    'courseSettings.importConfirm': '替换当前课程配置？进度会保留。',
    'courseSettings.importOk': '✓ 配置已导入，正在刷新…',
    'courseSettings.importFailed': '导入失败',
    'courseSettings.exportOk': '✓ 配置已下载',
    'courseSettings.clearProgress': '清空进度',
    'courseSettings.clearProgressConfirm': '确定清空错题、SRS、练习记录？此操作不可撤销。',
    'courseSettings.clearProgressOk': '✓ 进度已清空，正在刷新…',
    'courseSettings.deleteCourse': '删除整门课程',
    'courseSettings.deleteCourseConfirm1': '确定删除此课程？包括配置、内容、进度、上传的 PDF。',
    'courseSettings.deleteCourseConfirm2': '再次确认 — 此操作不可撤销。继续删除？',
    'courseSettings.saveOk': '✓ 已保存',
    'courseSettings.saveFailed': '保存失败',
    // Course creation form
    'form.createCourse': '新建课程',
    'form.step1.title': '基本信息',
    'form.step1.heading': '这门课叫什么？',
    'form.step1.courseTitle': '课程名称',
    'form.step1.courseTitlePlaceholder': '例：International Business / 概率论 / Brand Management',
    'form.step1.discipline': '专业方向',
    'form.step1.disciplineHumanities': '文史哲',
    'form.step1.disciplineLanguages': '外语',
    'form.step1.disciplineArts': '艺术与设计',
    'form.step1.disciplineBusiness': '商科',
    'form.step1.disciplineEconomics': '经济',
    'form.step1.disciplineLaw': '法学',
    'form.step1.disciplineSocial': '心理与社会',
    'form.step1.disciplineMathematics': '数学',
    'form.step1.disciplinePhysics': '物理',
    'form.step1.disciplineChemistry': '化学',
    'form.step1.disciplineBiology': '生物医学',
    'form.step1.disciplineCS': '计算机',
    'form.step1.disciplineEngineering': '工程',
    'form.step1.disciplineOther': '其他',
    'form.step1.customDisciplinePlaceholder': '填写专业方向（如：海洋工程 / 古典学）',
    'form.step1.pedagogy': '课程类型',
    'form.step1.pedagogyHint': '可多选；类型组合驱动默认组件。',
    'form.step1.pedagogyCase': '案例研讨',
    'form.step1.pedagogyConceptual': '概念框架',
    'form.step1.pedagogyQuantitative': '推导计算',
    'form.step1.pedagogyLab': '实验/实操',
    'form.step1.pedagogyMemorization': '记忆密集',
    'form.step1.pedagogyEssay': '论文写作',
    'form.step1.pedagogyCoding': '编程实现',
    'form.step1.pedagogyCustom': '自定义',
    'form.step1.customPedagogyPlaceholder': '填写课程类型（如：临床问诊 / 工作室评图）',
    'form.step1.examDate': '考试日期',
    'form.step1.examDateUnknown': '暂无具体日期',
    'form.step1.examDateUnknownHint': '后续可在课程设置随时补填。',
    'form.step1.dateYear': '年',
    'form.step1.dateMonth': '月',
    'form.step1.dateDay': '日',
    'form.step1.masteryHeading': '自评掌握度',
    'form.step1.masteryHelp': '决定 AI 生成内容的深度与风格——讲义详略 + 题目认知层级偏向。',
    'form.step1.masteryNovice': '完全不会',
    'form.step1.masteryNoviceDesc': '上传课程资料让 AI 教——高颗粒度教材式讲解 + 多 flashcards + 偏记忆/理解题',
    'form.step1.masteryPartial': '部分掌握',
    'form.step1.masteryPartialDesc': '工具书 + 关键讲解——概念 + 关键例子 + 偏理解/应用题',
    'form.step1.masteryReviewed': '听了所有课',
    'form.step1.masteryReviewedDesc': '大纲 + 关键 fact（cheat sheet 风）+ 偏分析/评估题',
    // Session 19AE: 4 语模式
    'form.step1.langHeading': '生成内容语言',
    'form.step1.langHelp': '决定 AI 用哪种语言生成 — 题目、解释、范文。中国学生备考英文考试，常受益于中文释义辅助理解。',
    'form.step1.langEn': '纯英语',
    'form.step1.langEnDesc': '题目、解释、范文全英 — 全英教学/全英考试',
    'form.step1.langEnZhGloss': '英语主导 + 中文释义',
    'form.step1.langEnZhGlossDesc': '主体英文，关键术语首次出现时括注中文（推荐 · 兼顾考试与理解）',
    'form.step1.langZhEnTerms': '中文主导 + 英文术语',
    'form.step1.langZhEnTermsDesc': '解释中文，专业术语保留英文原文（中文考试 + 英文文献）',
    'form.step1.langZh': '纯汉语',
    'form.step1.langZhDesc': '全中文，无英文 — 国内学生 + 中文考试',
    'form.step2.title': '考试形式',
    'form.step2.heading': '考试包含哪些题型？',
    'form.step2.examFormat': '题型组合',
    'form.step2.mcq': '选择题（MCQ）',
    'form.step2.tf': '判断题（True/False）',
    'form.step2.essay': '论述题（Essay）',
    'form.step2.shortAnswer': '简答题',
    'form.step2.duration': '考试时长（分钟）',
    'form.step2.mockHeading': '模考',
    'form.step2.mockHint': '想要几套模考？每套独立题源，互不重复——可在第 4 步上传 past paper 后选"严格"或"参考"风格。',
    'form.step2.mockNone': '不要',
    'form.step2.mockOne': '1 套',
    'form.step2.mockTwo': '2 套',
    'form.step2.mockThree': '3 套',
    'form.step2.paperLabel': '第',
    'form.style.contentBased': '内容驱动',
    'form.style.contentBasedDesc': '按 case 内容 + Bloom 分布出题',
    'form.style.pastPaperStrict': '严格 past paper',
    'form.style.pastPaperStrictDesc': '题数/题型/风格严格按 past paper（题目内容仍按 case 出）',
    'form.style.pastPaperInspired': '参考 past paper',
    'form.style.pastPaperInspiredDesc': '参考风格，AI 自由发挥',
    'form.style.needsPastPaper': '需先在第 4 步上传 past paper',
    'form.step3.title': '组件',
    'form.step3.heading': '想用哪些功能？',
    'form.step3.hint': '勾选你需要的组件——AI 只生成你勾选的内容，没勾的不浪费 token。',
    'form.step3.resetDefaults': '重置为推荐默认',
    'form.step3.resetDefaultsHint': '按当前「专业 × 类型」重新计算建议组件集。已经手动调整的勾选会被覆盖。',
    'form.step4.title': '上传材料',
    'form.step4.heading': '把课程材料给它',
    'form.step4.uploadHint': '支持 PDF / PPTX / Word。可一次拖入多个文件或整个文件夹；逐个标注是教材、讲义、past paper 还是其他。',
    'form.step4.review': '确认信息',
    'form.step4.pastPapersHeading': 'Past papers（选填）',
    'form.step4.pastPapersHint': '上传往年试卷，模考可选"严格"或"参考"风格。可上传多份，默认绑定最新年份。',
    'form.step4.addPastPaper': '+ 添加 past paper',
    'form.step4.pastPaperYear': '年份',
    'form.step4.pastPaperLabel': '描述（可选）',
    'form.step4.pastPaperRemove': '移除',
    // Session 19AD: multi-source slot upload
    'form.step4.slotsHeading': '课程材料',
    'form.step4.slotsHint': '同时拖入多个文件，给每份打个类型——教材 / 讲义 / past paper / 案例 / 大纲 / 阅读 / 自定义。AI 按类型分流，不必猜你扔的是啥。',
    'form.step4.addFiles': '+ 添加文件',
    'form.step4.addFolder': '+ 添加文件夹',
    'form.step4.dropZone': '拖文件到这儿，或点上面按钮选择',
    'form.step4.kindLabel': '类型',
    'form.step4.labelLabel': '标签（可选）',
    'form.step4.labelPlaceholder': '例：第3章、2024 final',
    'form.step4.priorityLabel': '优先级',
    'form.step4.customNoteLabel': '自定义说明',
    'form.step4.customNotePlaceholder': '简短描述这是什么材料',
    'form.step4.removeSlot': '移除',
    'form.step4.kind.textbook': '教材',
    'form.step4.kind.lectureNotes': '讲义',
    'form.step4.kind.pastPaper': 'Past paper',
    'form.step4.kind.syllabus': '大纲',
    'form.step4.kind.caseStudy': '案例',
    'form.step4.kind.reading': '阅读',
    'form.step4.kind.custom': '自定义',
    'form.step4.kind.exercise': '练习题',
    'form.step4.kind.rubric': '评分标准',
    'form.step4.kind.assignment': '作业',
    'form.step4.kindHelp.textbook': '主参考书 / 章节',
    'form.step4.kindHelp.lectureNotes': 'Slides / 课堂笔记',
    'form.step4.kindHelp.pastPaper': '往年试卷',
    'form.step4.kindHelp.syllabus': '课程大纲',
    'form.step4.kindHelp.caseStudy': 'Case 阅读 (Harvard 等)',
    'form.step4.kindHelp.reading': '辅助阅读',
    'form.step4.kindHelp.custom': '其它（请填说明）',
    'form.step4.kindHelp.exercise': '习题集 / 练习册',
    'form.step4.kindHelp.rubric': '评分方案 / 答案标准',
    'form.step4.kindHelp.assignment': '课程作业 / 任务',
    'form.step4.formatBadge.pdf': 'PDF',
    'form.step4.formatBadge.pptx': 'PPTX',
    'form.step4.formatBadge.docx': 'Word',
    'form.step4.formatBadge.md': 'Markdown',
    'form.step4.formatBadge.txt': '文本',
    'form.step4.unsupportedFormat': '不支持的格式',
    'form.step4.parseError': '解析失败',
    // Home / course list
    'home.title': '我的课程',
    'home.subtitle': '把课件转成考完即弃的备考工件。',
    'home.empty': '还没有课程',
    'home.emptyHint': '上传一份课程材料，开始你的第一个备考工件。',
    'home.openCourse': '打开',
    'create.saveDraftFailed': '保存课程草稿失败：{message}',
    'schemaVersion.needRegen': '需要重新生成此课程内容以解锁此模块。',
    'schemaVersion.minRequired': '最小要求 schema {required}',
    'schemaVersion.currentVersion': '当前 {actual}',
    'schemaVersion.currentUndefined': '当前未声明版本',
    'home.draftMeta': '已保存 · 未生成',
    // Course view
    'course.loading': '正在读取课程…',
    'course.notFound': '找不到这门课程',
    'course.notFoundHint': '可能已被删除，或链接来自其他设备。',
    'course.backHome': '返回首页',
    'sidebar.courseCode': '课程代码',
    'sidebar.courseCodeUnset': '未设课程代码',
    'resultView.noCases': '没有生成的案例题。',
    'resultView.noFlashcards': '没有生成的抽认卡。',
    'resultView.noMcqs': '没有生成的选择题。',
    'course.generateHeading': '准备生成',
    'course.generateBody': '点击下方按钮，AI 会按你勾选的组件从 PDF 生成内容。生成约需 30 秒至几分钟。',
    'course.generateNow': '开始生成',
    'course.generating': '正在生成中…',
    'course.generatingHint': 'AI 正在解析 PDF 并生成卡片、题目、解析。请耐心等待。',
    'course.regenerate': '内容生成',
    'course.regenerateConfirm': '内容生成会覆盖现有内容。继续？',
    'course.errorHeading': '生成失败',
    'course.errorRetry': '重试',
    'course.uploadMissing': '找不到原始 PDF。可能浏览器存储被清理。请重新创建课程。',
    'course.pasteJsonAlt': '已经有生成好的内容？直接粘贴',
    'course.pasteJsonHeading': '粘贴现成的课程内容',
    'course.pasteJsonHint': '如果你在其他工具（比如 Claude 网页版）已经生成了课程数据文件，可以直接贴在这里跳过本地生成。',
    'course.pasteJsonHintSchema': '内容必须包含必填字段：课程 id、标题、章节列表（至少 1 章）、闪卡和选择题数组；其余题型（判断、论述、词汇、思维导图、证明等）可选。',
    'course.pasteJsonPlaceholder': '在此粘贴课程内容…',
    'course.pasteJsonValidateAndSave': '校验并保存',
    'course.pasteJsonInvalid': '内容格式无效，无法解析',
    'course.pasteJsonValidationFailed': '内容结构与要求不符',
    'course.pasteJsonLegacyMigrated': '检测到旧版字段，已自动迁移：{rules}',
    'course.skipReview': '跳过审查（全自动）',
    'course.extractingOutline': '正在提取大纲…',
    'course.extractingOutlineHint': 'AI 正在分析源材料结构，请稍等几分钟',
    'course.cancel': '取消',
    'course.previewTab': '原始数据',
    // Dashboard
    'dashboard.daysUntilExam': '天后考试',
    'dashboard.examComingSoon': '即将到来',
    'dashboard.examPassed': '考试已过',
    'dashboard.examToday': '今天考试',
    'dashboard.flashcardsDue': '张待复习',
    'dashboard.flashcardsTotal': '共 {count} 张',
    'dashboard.wrongAnswersUnresolved': '题待攻克',
    'dashboard.recommendedNext': '建议下一步',
    'dashboard.openModule': '打开',
    'dashboard.noActivityYet': '尚无学习记录——从任意模块开始即可。',
    'dashboard.viewByChapter': '按章节',
    'dashboard.viewByTopic': '按主题',
    'dashboard.chapterBreakdown': '各章节进度',
    'dashboard.topicBreakdown': '各主题进度',
    'dashboard.weakestChapters': '薄弱章节',
    'dashboard.weakestTopics': '薄弱主题',
    'dashboard.cognitiveDistribution': '认知层级分布',
    'dashboard.cognitiveDistributionHelp': '按 Bloom 认知层级分类题目：记忆 / 理解 / 应用 / 分析 / 评估。比例越靠右，题目越偏深度思考。',
    'dashboard.cogRecall': '记忆',
    'dashboard.cogUnderstand': '理解',
    'dashboard.cogApply': '应用',
    'dashboard.cogAnalyze': '分析',
    'dashboard.cogEvaluate': '评估',
    'dashboard.cogUnlabeled': '未标',
    // ── 19BO+ B5.3 章×认知层级热图 ──
    'dashboard.heatmapTitle': '章节 × 认知层级 错题热图',
    'dashboard.heatmapHelp': '颜色越深，该章节该认知层级未解决的错题越多。点击章节展开练习入口。',
    'dashboard.heatmapExpandHint': '点击展开',
    'dashboard.heatmapCellTitle': '{chapter} · {level}：未解决 {unresolved} / 共错过 {total}',
    'dashboard.heatmapPracticeFlashcard': '练本章闪卡',
    'dashboard.heatmapPracticeQuiz': '练本章测验',
    'dashboard.mastery': '掌握度',
    'dashboard.noTopicsYet': '暂无主题层级数据——本课程内容用旧版生成时不带 topic 标签；重新跑内容生成可解锁主题视图。',
    'dashboard.dueShort': '到期',
    'dashboard.unresolvedShort': '错题',
    'dashboard.bookmarkedShort': '收藏',
    'dashboard.itemsShort': '题/卡',
    'dashboard.showContents': '展开本章内容',
    'dashboard.hideContents': '收起内容',
    'dashboard.essaysDrafted': '已写 essay',
    'dashboard.itemKindTf': '判断题',
    'dashboard.itemKindNote': '讲义',
    'dashboard.familyGenerative': '学材料',
    'dashboard.familyDiscrimination': '测自己',
    'dashboard.familySynthesis': '论述演练',
    // 19BO+ Line 2 B4.3 · AI 弱项诊断触发
    'dashboard.diagnoseBtn': 'AI 弱项诊断',
    'dashboard.diagnoseRescoreBtn': '重新诊断',
    // Mock exam
    'mockExam.heading': '模拟考试',
    'mockExam.setupHeading': '准备开始模考',
    'mockExam.setupBody': '点击开始后倒计时启动；中途可暂停吗？不能——和真实考试一致。可以标记"待复查"，最后再回看。',
    'mockExam.formatLine': '题型：{format}',
    'mockExam.durationLine': '时长：{minutes} 分钟',
    'mockExam.start': '开始模考',
    'mockExam.empty': '当前课程未启用模考',
    'mockExam.emptyHint': '回到组件页打开「模拟考试」组件，再到刷题模块生成内容。',
    'mockExam.timeRemaining': '剩余 {time}',
    'mockExam.timeUp': '时间到 — 已自动提交',
    'mockExam.questionNum': '第 {n} 题',
    'mockExam.markReview': '标记复查',
    'mockExam.unmarkReview': '取消标记',
    'mockExam.tfTrue': '正确',
    'mockExam.tfFalse': '错误',
    'mockExam.submit': '提交模考',
    'mockExam.submitConfirm': '还有 {remaining} 题未答。确认提交？',
    'mockExam.finishedHeading': '模考结束',
    'mockExam.finishedScore': '得分：{correct} / {total}（{percent}%）· 用时 {minutes} 分',
    'mockExam.finishedReview': '查看答题情况',
    'mockExam.finishedRestart': '再来一次',
    'mockExam.finishedHome': '回总览',
    'mockExam.statAnswered': '已答 {n}',
    'mockExam.statMarked': '标记 {n}',
    'mockExam.statRemaining': '未答 {n}',
    'mockExam.paperCountQ': '生成几套模考？',
    'mockExam.paperCountHint': '每套题集独立抽样；可分别完成。上限 3 套（题库不够时会提示）。',
    'mockExam.generate': '生成 {n} 套',
    'mockExam.pickPaperHeading': '选一套来做',
    'mockExam.pickPaperBody': '已生成 {n} 套独立模考。点开始考。',
    'mockExam.paperLabel': '第 {n} 套',
    'mockExam.paperItems': '{n} 题',
    'mockExam.paperPending': '未做',
    'mockExam.paperDone': '已完成',
    'mockExam.paperScore': '{correct}/{total}',
    'mockExam.openPaper': '开考',
    'mockExam.backToPicker': '回选卷',
    'mockExam.nextPaper': '下一套',
    'mockExam.unconfiguredHeading': '还未配置模考',
    'mockExam.unconfiguredBody': '模考的套数与风格在课程设置里编辑——点下面进入，配置完回来即可开考。',
    'mockExam.goToSettings': '去课程设置',
    'mockExam.openSettings': '课程设置',
    'mockExam.createPaper': '新建模拟试卷',
    'mockExam.regenerateSample': '重新抽题',
    'mockExam.regenerateSampleHint': '从当前题库重新抽样生成 papers（不影响 CourseDraft 配置）。',
    'mockExam.prevItem': '上一题',
    'mockExam.nextItem': '下一题',
    'mockExam.reviewHeading': '逐题对答案',
    'mockExam.reviewCorrect': '答对',
    'mockExam.reviewWrong': '答错',
    'mockExam.reviewUnanswered': '未作答',
    'mockExam.reviewAnswer': '正确答案',
    'mockExam.reviewYourAnswer': '你选的',
    'mockExam.reviewExplanation': '解析',
    'mockExam.essayLabel': '论述题',
    'mockExam.essayScaffold': '答题框架',
    'mockExam.essayKeyPoints': '关键得分点',
    'mockExam.essayModelAnswer': '范文',
    // Mindmap
    'mindmap.heading': '思维导图',
    'mindmap.empty': '没有思维导图',
    'mindmap.emptyHint': '当前课程未生成思维导图。回组件页启用 mindmap 组件后再生成。',
    'mindmap.pickCase': '选择章节',
    'mindmap.toolbarReset': '居中',
    'mindmap.toolbarFit': '适配',
    // Essay
    'essay.heading': 'Essay 练习',
    'essay.empty': '没有 Essay 题',
    'essay.notFound': '找不到这道 Essay 题',
    'essay.emptyHint': '当前课程未生成 essay。回组件页启用 essay 组件后再生成。',
    'essay.colPrompt': '题目',
    'essay.colCase': 'Case',
    'essay.colWordTarget': '字数目标',
    'essay.colStatus': '状态',
    'essay.statusEmpty': '未开始',
    'essay.statusDraft': '草稿',
    'essay.statusGraded': '已评分',
    'essay.detailPrompt': '题干',
    'essay.detailScaffold': '答题脚手架',
    'essay.detailModelAnswer': '参考答案',
    'essay.detailKeyPoints': '采分点',
    'essay.editorTitle': '我的回答',
    'essay.editorPlaceholder': '在此输入你的论述…',
    'essay.wordCount': '{n} 词',
    'essay.wordTargetLabel': '目标 {n} 词',
    'essay.savedAt': '已保存 · {time}',
    'essay.copyMd': '复制 Markdown',
    'essay.copyHtml': '复制 HTML',
    'essay.exportMd': '下载 .md',
    'essay.copied': '已复制 ✓',
    'essay.aiScoreBtn': 'AI 评分',
    'essay.aiScoreTooltip': '高级版功能 · 商业化预留',
    'essay.aiScoreFuture': '高级版功能：AI 自动评分按 token 计费。当前免费版可用对照范文 + 关键点自评。',
    'essay.toolbarBold': '粗体',
    'essay.toolbarItalic': '斜体',
    'essay.toolbarH1': 'H1',
    'essay.toolbarH2': 'H2',
    'essay.toolbarList': '列表',
    'essay.toolbarOrdered': '有序',
    'essay.toolbarQuote': '引用',
    'essay.toolbarCode': '代码',
    'essay.toolbarLink': '链接',
    'essay.backToList': '← 回 Essay 列表',
    // Flashcards
    'flashcards.heading': '闪卡',
    'flashcards.empty': '没有闪卡',
    'flashcards.emptyHint': '当前课程未生成闪卡。回到组件页打开闪卡组件后再生成。',
    'flashcards.reviewAll': '复习全部',
    'flashcards.flipHint': '空格 / 回车 翻面',
    'flashcards.rateAgain': '不会',
    'flashcards.rateHard': '困难',
    'flashcards.rateGood': '良好',
    'flashcards.rateEasy': '容易',
    'flashcards.cardCounter': '第 {current} / {total} 张',
    'flashcards.boxLabel': '记忆等级',
    'flashcards.filterByCase': '按 case 筛选',
    'flashcards.allCases': '全部',
    'flashcards.sessionDone': '本轮已完成',
    'flashcards.sessionDoneHint': '所有到期闪卡都已复习。可以回到总览或继续刷题。',
    'flashcards.sessionCorrect': '本轮 {good} / {total} 张评为「良好」或以上。',
    'flashcards.startNew': '开始新一轮',
    'flashcards.shortcuts': '快捷键：空格/回车 翻面 · 1 不会 · 2 困难 · 3 良好 · 4 容易',
    // Quiz
    'quiz.heading': '刷题',
    'quiz.setupHeading': '配置本次刷题',
    'quiz.pickCase': '范围',
    'quiz.pickCount': '题量',
    'quiz.start': '开始',
    'quiz.empty': '没有题目',
    'quiz.emptyHint': '当前课程未生成 MCQ。回到组件页打开「刷题」后再生成。',
    'quiz.questionCounter': '第 {current} / {total} 题',
    'quiz.correct': '答对',
    'quiz.incorrect': '答错',
    'quiz.explanation': '解析',
    'quiz.showAnswer': '查看答案',
    'quiz.nextQuestion': '下一题',
    'quiz.finishedHeading': '本轮完成',
    'quiz.finishedScore': '成绩：{correct} / {total}（{percent}%）',
    'quiz.finishedReviewWrong': '到错题本看错题',
    'quiz.finishedRestart': '再来一轮',
    'quiz.finishedBackToHub': '回总览',
    'quiz.shortcuts': '快捷键：A/B/C/D 或 1/2/3/4 选题 · → 下一题',
    // Glossary (Session 19X · v1↔v2 parity)
    'glossary.heading': '词汇表',
    'glossary.subtitle': '术语速查——支持搜索、按字母跳转、按章节过滤。',
    'glossary.empty': '词汇表为空',
    'glossary.emptyHint': '本课程当前没有词条。重新跑内容生成可补全。',
    'glossary.searchPlaceholder': '搜索术语 / 定义…（按 / 聚焦）',
    'glossary.filterAllCases': '全部章节',
    'glossary.filterUnscoped': '未分章节',
    'glossary.alphaIndex': '字母索引',
    'glossary.noMatches': '无匹配词条。',
    'glossary.totalTerms': '共 {count} 词条',
    'glossary.relatedCases': '关联章节',
    'glossary.shortcutFocusSearch': '快捷键 / 聚焦搜索',
    'glossary.expandAll': '全部展开',
    'glossary.collapseAll': '全部折叠',
    // Bookmarks
    'bookmarks.heading': '收藏夹',
    'bookmarks.subtitle': '主动收藏的题目和闪卡——不论对错。',
    'bookmarks.empty': '收藏夹为空',
    'bookmarks.emptyHint': '在闪卡或刷题界面点收藏图标，加进来的项目会出现在这里。',
    'bookmarks.addBookmark': '加入收藏',
    'bookmarks.removeBookmark': '取消收藏',
    'bookmarks.filterAll': '全部',
    'bookmarks.filterMcq': '题目',
    'bookmarks.filterFlashcard': '闪卡',
    'bookmarks.colItem': '内容',
    'bookmarks.colCase': 'Case',
    'bookmarks.colType': '类型',
    'bookmarks.colAddedAt': '收藏于',
    'bookmarks.typeMcq': '题目',
    'bookmarks.typeFlashcard': '闪卡',
    'bookmarks.drillSelected': '只刷选中',
    'bookmarks.drillAll': '刷收藏的题',
    // Quiz resume
    'quiz.resumeHeading': '检测到未完成的刷题',
    'quiz.resumeBody': '上次刷到第 {current} / {total} 题。要继续吗？',
    'quiz.resumeContinue': '继续上次',
    'quiz.resumeAbandon': '放弃重开',
    'quiz.resumeAbandonConfirm': '放弃当前进度，从配置开始重新刷？',
    // Wrong answers
    'wrongAnswers.heading': '错题本',
    'wrongAnswers.subtitle': '自动追踪做错的题目；正确次数 ≥ 错误次数后视为已掌握。',
    'wrongAnswers.empty': '错题本为空',
    'wrongAnswers.emptyHint': '到刷题模块做几题，错的会自动出现在这里。',
    'wrongAnswers.filterAll': '全部',
    'wrongAnswers.filterUnresolved': '待攻克',
    'wrongAnswers.filterResolved': '已掌握',
    'wrongAnswers.colQuestion': '题目',
    'wrongAnswers.colCase': 'Case',
    'wrongAnswers.colStatus': '状态',
    'wrongAnswers.colWrong': '错',
    'wrongAnswers.colCorrect': '对',
    'wrongAnswers.colLastWrong': '上次错于',
    'wrongAnswers.statusUnresolved': '待攻克',
    'wrongAnswers.statusResolved': '已掌握',
    'wrongAnswers.drillSelected': '只刷选中',
    'wrongAnswers.drillAll': '刷全部待攻克',
    // Health badge
    'health.idle': '空闲',
    'health.checking': '检查中…',
    'health.ok': '在线',
    'health.degraded': '响应慢',
    'health.offline': '离线',
    'health.notConnected': '未连接生成服务',
    'health.pasteJsonMode': '已粘贴现成内容 · 无需联网',
    // Theme toggle (session 42)
    'theme.light': '浅色模式',
    'theme.dark': '深色模式',
    'theme.system': '跟随系统',
    // Auth / account stub (session 43)
    'auth.login': '登录',
    'auth.logout': '退出登录',
    'auth.anonymous': '匿名用户',
    'auth.profile': '个人资料',
    // auth (19BN Phase 1 expansion)
    'auth.email': '邮箱地址',
    'auth.password': '密码',
    'auth.confirmPassword': '确认密码',
    'auth.displayName': '显示名（可选）',
    'auth.inviteCode': '邀请码（可选）',
    'auth.welcome': '欢迎回来',
    'auth.createAccount': '创建账户',
    'auth.signUp': '注册',
    'auth.orDivider': '或',
    'auth.magicLinkLogin': '用邮箱链接登录',
    'auth.haveAccount': '已有账户？',
    'auth.noAccount': '还没有账户？',
    'auth.forgotPassword': '忘记密码？',
    'auth.sending': '提交中…',
    'auth.loginFailed': '邮箱或密码不正确',
    'auth.emailTaken': '该邮箱已注册',
    'auth.weakPassword': '密码至少 8 位',
    'auth.invalidEmail': '请输入有效的邮箱地址',
    'auth.passwordMismatch': '两次密码不一致',
    'auth.changePassword': '修改密码',
    'auth.currentPassword': '当前密码',
    'auth.newPassword': '新密码（至少 8 位）',
    'auth.passwordChanged': '密码已修改',
    'auth.loginSuccess': '登录成功',
    'auth.logoutConfirm': '确认退出登录？',
    'auth.signupSuccess': '注册成功',
    'auth.welcomeBonus': '注册即送 1,000 点',
    'auth.welcomeBonusSub': '够 5-6 次完整建课',
    'auth.magicSent': '验证邮件已发送',
    'auth.magicSentHint': '我们已将登录链接发送至你的邮箱。链接 15 分钟内有效。收不到？检查垃圾邮件。',
    'auth.resend': '重新发送',
    'auth.magicVerifySuccess': '登录成功',
    'auth.magicVerifyFailed': '链接已过期或无效',
    'auth.magicVerifyPending': '正在为你登录…',
    'auth.magicVerifyFailedHint': '此登录链接无效、已过期或已被使用。请重新获取登录链接。',
    // 19BO+ Phase B: 两段化注册（申请 → 邮件确认 → 登录）
    'auth.signupSent': '验证邮件已发送',
    'auth.signupSentHint': '我们已将确认链接发送至你的邮箱。点击链接即可完成注册。链接 15 分钟内有效。收不到？检查垃圾邮件。',
    'auth.signupVerifyPending': '正在确认你的账户…',
    'auth.signupVerifySuccess': '注册成功',
    'auth.signupVerifyFailed': '链接已过期或无效',
    'auth.signupVerifyFailedHint': '此确认链接无效、已过期或已被使用。请重新注册以获取新的链接。',
    'auth.wrongCurrentPassword': '当前密码不正确',
    'auth.agreeTerms': '我已阅读并同意 服务条款',
    'auth.viewPassword': '显示密码',
    'auth.hidePassword': '隐藏密码',
    'auth.pwStrengthWeak': '弱',
    'auth.pwStrengthMedium': '中',
    'auth.pwStrengthStrong': '强',
    'auth.pwMinLength': '至少 8 位',
    // account (19BN Phase 2)
    'account.myPoints': '我的点数',
    'account.points': '点',
    'account.coursesWorth': '门完整课程',
    'account.recharge': '充值',
    'account.balance': '点数余额',
    'account.insufficientCredits': '点数不足，请充值后再试',
    'account.viewHistory': '查看明细',
    'account.creditsHistory': '点数明细',
    'account.lowBalanceTitle': '点数余额偏低',
    'account.lowBalanceBody': '当前余额 {balance} 点，已低于提醒阈值（{threshold} 点）。建议尽快充值。',
    // Regen view
    'regen.title': '内容生成',
    'regen.tabPartial': '批量操作',
    'regen.tabHistory': '历史记录',
    'regen.tabSettings': '设置',
    'regen.fullDesc': '重新提取大纲 → 确认 → 全量生成。会覆盖现有所有内容。',
    'regen.fullStart': '开始全部内容生成',
    'regen.partialStart': '开始生成',
    'regen.preparing': '正在准备…',
    'regen.runningJob': '正在生成 {stage}（{done}/{total}）',
    'regen.generating': '正在生成…',
    'regen.done': '生成完成',
    'regen.failed': '生成失败',
    'regen.reset': '重新选择',
    'regen.selectChapters': '选择章节',
    'regen.selectStages': '选择阶段',
    'regen.selectAll': '全选',
    'regen.deselectAll': '取消全选',
    'regen.historyDesc': '查看和回退历史生成操作。',
    'regen.historyLoading': '加载中…',
    'regen.historyEmpty': '暂无历史记录',
    'regen.rollback': '回退',
    'regen.rollbackConfirm': '确认回退此操作？已生成的内容将被还原。',
    'regen.replaceLabel': '替换',
    'regen.addLabel': '新增',
    'regen.deleteLabel': '删除',
    'regen.fixLabel': '修复',
    'regen.statusApplied': '已应用',
    'regen.statusPending': '待确认',
    'regen.statusRejected': '已拒绝',
    'regen.statusRolledBack': '已回退',
    'regen.appliedN': '已应用 {n} 项',
    'regen.noChapters': '无大纲章节，请先生成内容',
    'regen.historyLoadFailed': '历史记录加载失败：{error}',
    'regen.historyDbUnavailable': '历史记录需要 D1 数据库——本地开发环境无 D1 绑定，请部署后查看',
    // Regen settings
    'regen.settingsAutoApply': '自动应用',
    'regen.settingsAutoApplyDesc': '跳过预览确认步骤，直接替换原内容。',
    'regen.settingsAutoApplyWarn': '开启后内容生成的结果将直接替换，无法逐项审查。',
    'regen.settingsAddCount': '默认新增数量',
    'regen.settingsAddCountDesc': '点击“生成更多”时默认生成的题目数量。',
    // Item action menu (embedded regen · session 19BJ)
    'itemAction.buttonLabel': '内容生成',
    'itemAction.replace': '重新生成此题',
    'itemAction.addMore': '生成更多类似题',
    'itemAction.delete': '删除此题',
    'itemAction.hint': '带提示重新生成…',
    'itemAction.hintPlaceholder': '输入你的提示或要求…',
    'itemAction.cancel': '取消',
    'itemAction.generate': '生成',
    // Notification center
    'notif.centerTitle': '通知',
    'notif.messageCenter': '消息中心',
    'notif.empty': '暂无通知',
    'notif.emptyHint': '系统消息将自动显示在此处。',
    'notif.emptyFiltered': '当前分类下暂无通知',
    'notif.markAllRead': '全部已读',
    'notif.clearAll': '清空',
    'notif.viewAll': '查看全部',
    'notif.tabAll': '全部',
    'notif.tabStudy': '学习',
    'notif.tabSystem': '系统',
    'notif.tabAccount': '账户',
    // Regen notifications
    'regen.notifStarted': '开始生成 {stage}',
    'regen.notifCompleted': '{stage}生成完成 · {count}题 · 耗时 {duration}',
    'regen.notifFailed': '{stage}生成失败',
    'regen.notifInterrupted': '{stage}生成因页面刷新中断，请重新开始',
    'regen.notifView': '查看',
    'ingest.title': '正在生成课程内容',
    'ingest.hint': '内容会按阶段一步步生成，不要关闭页面。整个过程通常需要十多分钟到数十分钟，取决于课程组件和资料量，请耐心等待。',
    'ingest.statusSkipped': '跳过',
    'ingest.statusError': '失败',
    'ingest.errorsSummary': '失败的步骤',
    'ingest.stage.parseFiles': '读取上传文件',
    'ingest.stage.bundlePastPapers': '整理往年试卷',
    'ingest.stage.extractCases': '抽取章节结构',
    'ingest.stage.flashcards': '生成闪卡',
    'ingest.stage.mcqs': '生成选择题',
    'ingest.stage.trueFalse': '生成判断题',
    'ingest.stage.essays': '生成论述题',
    'ingest.stage.mindmaps': '生成思维导图',
    'ingest.stage.glossary': '生成词汇表',
    'ingest.stage.lectureNotes': '生成讲义',
    'ingest.stage.proofDrills': '生成证明题',
    'ingest.stage.freeResponses': '生成自由作答题',
    'ingest.stage.readingPassages': '生成阅读理解',
    'ingest.stage.mockPapers': '生成模考卷',
    'ingest.stage.audit': '质量检查',
    // Session 19AE: skip-reason copy
    'ingest.skipReason.noFiles': '本次未上传',
    'ingest.skipReason.noPastPaper': '本次未上传往年试卷',
    'ingest.skipReason.componentDisabled': '本课程未启用',
    'ingest.skipReason.noMockSpec': '未配置模考卷',
    'ingest.skipReason.outlineLocked': '大纲已锁定',
    // Session 19AE: lecture-notes-view
    'lectureNotes.empty': '暂无讲义',
    'lectureNotes.emptyHint': '勾选"讲义"组件并生成内容以获取讲义。',
    'lectureNotes.keyPointsHeading': '复习要点',
    'lectureNotes.relatedGlossary': '相关术语',
    'lectureNotes.source': '来源',
    'lectureNotes.likelihoodHigh': '考点概率高',
    'lectureNotes.likelihoodMid': '考点概率中',
    'lectureNotes.likelihoodLow': '考点概率低',
    // Session 19AH: proof-drills-view
    'proofDrills.empty': '暂无证明题',
    'proofDrills.emptyHint': '勾选"证明推导"组件并生成内容以获取此章节的证明题。',
    'proofDrills.keyStepsHeading': '推导步骤',
    'proofDrills.commonMistakesHeading': '常见错误',
    // Session 19AN: progressive step reveal
    'proofDrills.revealStep': '展示这一步',
    'proofDrills.revealAll': '展示全部步骤',
    'proofDrills.hideAll': '折叠全部步骤',
    'proofDrills.stepLabel': '第 {n} 步',
    'proofDrills.tryFirst': '先自己尝试推导，再点开下方步骤对照。',
    'proofDrills.justificationLabel': '为什么这一步成立',
    // Session 19AN: stale state banner
    'course.staleBanner': '课程参数已变（源文件 / 学科 / 教学方式 / 模考配置等），当前内容可能与最新设置不一致。',
    'course.staleRegenerate': '内容生成',
    // Session 19AO: subjective wrong-answers tab + stats
    'wrongAnswers.tabObjective': '客观题 (MCQ / T/F)',
    'wrongAnswers.tabSubjective': '主观题 (essay / 简答 / 推导)',
    'wrongAnswers.subjectiveEmpty': '暂无主观题作答记录。先到 essay / 自由作答 / 证明推导 写下你的答案并自评。',
    'wrongAnswers.subjectiveStatTotal': '已作答',
    'wrongAnswers.subjectiveStatNeedsRevisit': '需重练（平均分 <2/3）',
    'wrongAnswers.subjectiveStatByType': '按题型',
    'wrongAnswers.subjectiveWeakest': '最弱的题（按最近自评平均分排序）',
    // Session 19AP: shared self-assess panel
    'essay.selfAssessHeading': '自评 · 写完后给自己打分',
    'essay.selfAssessHint': '0=没达成 / 1=部分 / 2=基本对 / 3=完全到位。诚实打分本身就是练习。',
    'proofDrills.selfAssessHeading': '自评 · 推完后给自己打分',
    'proofDrills.selfAssessHint': '0=思路不对 / 1=有想法但卡住 / 2=步骤基本对 / 3=每一步都站得住。',
    // Session 19AP: dashboard subjective summary
    'dashboard.subjectiveAvg': '自评 {avg}/3',
    'dashboard.subjectiveNeedsRevisit': '需重练',
    // Session 19AN: free-response view
    'freeResponse.empty': '暂无自由作答题',
    'freeResponse.emptyHint': '勾选"自由作答"组件并生成内容以获取此课程的题目。',
    'freeResponse.kind.short_answer': '简答题',
    'freeResponse.kind.calculation': '计算题',
    'freeResponse.kind.translation': '翻译题',
    'freeResponse.scaffoldHeading': '答题思路提示',
    'freeResponse.hintsHeading': '渐进提示',
    'freeResponse.hintsEmpty': '点击下方按钮逐步揭示提示。',
    'freeResponse.revealHint': '揭示提示 {n}/{total}',
    'freeResponse.responseHeading': '你的答案',
    'freeResponse.responsePlaceholder': '在这里写下你的答案。可使用 markdown，数学用 $...$ 或 $$...$$。',
    'freeResponse.commit': '提交并对照参考',
    'freeResponse.commitEmptyConfirm': '答案为空，确定提交？',
    'freeResponse.reset': '重做',
    'freeResponse.resetConfirm': '重做将清除当前作答与自评。继续？',
    'freeResponse.referenceHeading': '参考答案',
    'freeResponse.reasoningHeading': '解题思路',
    'freeResponse.finalValueLabel': '最终结果',
    'freeResponse.sourceTextHeading': '原文（待翻译）',
    'freeResponse.targetLanguage': '目标语言：{lang}',
    'freeResponse.selfAssessHeading': '自评 · 按维度打分（0-3）',
    'freeResponse.selfAssessHint': '0=未达成；1=部分达成；2=基本达成；3=完全达成。诚实自评是这一题型的核心练习。',
    // Session 19AN: reading-passage view
    'readingPassage.empty': '暂无阅读理解',
    'readingPassage.emptyHint': '勾选"阅读理解"组件并生成内容以获取阅读材料。',
    'readingPassage.passageHeading': '阅读材料',
    'readingPassage.questionsHeading': '配套题目',
    'readingPassage.wordCount': '约 {n} 词',
    'readingPassage.sourceCredit': '来源：{credit}',
    // Session 19AE: progress detail UI
    'ingest.totalElapsed': '已用时',
    'ingest.aiCallBadge': '此阶段调用 AI',
    'ingest.recoverableSingle': '1 个阶段失败，但已可恢复 — 流程继续',
    'ingest.recoverableMulti': '{n} 个阶段失败，但已可恢复 — 流程继续',
    'ingest.finalizing': '质量检查中…',
    'ingest.group.prep': '准备阶段',
    'ingest.group.generate': 'AI 生成内容',
    'ingest.group.qa': '质量检查',
    'ingest.group.doneSummary': '{n} 项已完成',
    'ingest.group.inProgress': '进行中…',
    'ingest.hero.running': '正在{stage}',
    'ingest.hero.runningHint': '此阶段通常需要 {min}-{max} 分钟',
    'ingest.hero.done': '正在完成最后步骤…',
    'ingest.hero.elapsedLabel': '已用时',
    'ingest.lowYield': '素材有限',
    'ingest.lowYieldTip': '源材料内容有限，已尽力生成。部分题目数量少于预期。',
    'ingest.lowYieldBannerSingle': '{stage} 的生成数量低于预期 — 源材料内容有限，已尽力生成。',
    'ingest.lowYieldBannerMulti': '{n} 个模块的生成数量低于预期 — 源材料内容有限，已尽力生成。',
    'mockExam.styleStrict': '严格 past paper',
    'mockExam.styleInspired': '参考 past paper',
    'mockExam.styleContent': '内容驱动',
    'mockExam.fallbackBanner': '⚠ 独立模考题未生成或不足，当前从日常题库抽样 fallback。重新跑内容生成可重试 mock_papers stage。',
    'wrongAnswers.statsHeading': '错题统计',
    'wrongAnswers.statTotal': '总数',
    'wrongAnswers.statUnresolved': '未解决',
    'wrongAnswers.statResolved': '已解决',
    'wrongAnswers.statByCase': '按章节',
    'wrongAnswers.statByCategory': '按题型分类',
    'wrongAnswers.statTrend': '近 {n} 天错题趋势',
    'wrongAnswers.trendAxis': '近 {n} 天（左→右越近）',
    // Footer (session 44)
    'footer.allRightsReserved': '版权所有',
    'footer.email': '邮箱',
    'footer.wechat': '公众号',
    'footer.bilibili': 'B站',
    'footer.douyin': '抖音',
    'footer.xiaohongshu': '小红书',
    // Subjective feedback (19BM-F · Cmd+/ hotkey · 渐进式三态面板)
    'feedback.title': '反馈',
    'feedback.subtitle': '哪里不对劲？',
    'feedback.categoryOff': '不对劲',
    'feedback.categoryMissing': '想要的没有',
    'feedback.categorySlow': '太慢',
    'feedback.categoryOther': '其他',
    'feedback.noteLabel': '备注（可选）',
    'feedback.notePlaceholder': '补充说明（≤500 字）',
    'feedback.submit': '提交反馈',
    'feedback.expand': '写详情',
    'feedback.collapse': '收起',
    'feedback.submitted': '已记录，谢谢',
    'feedback.duplicate': '刚刚已提交过，稍后再试',
    'feedback.failed': '记录失败，请重试',
    // ── Admin: usage-page (19BM-D · /admin?key=... 跨用户 D1 后台) ───────
    'admin.title': '考完即弃 · 操作者后台',
    'admin.subtitle': 'ExamForge admin · D1 跨用户遥测 · 朋友 alpha 期质量 + 成本 + flag 全可观测',
    'admin.tab.overview': '总览',
    'admin.tab.users': '用户',
    'admin.tab.ingests': 'Ingest',
    'admin.tab.repairs': 'Repair',
    'admin.tab.feedback': '反馈',
    'admin.tab.events': '事件',
    'admin.search.hint': '搜索 anon_id / 课程 / item_id / summary',
    'admin.search.placeholder.default': '搜索…',
    'admin.search.placeholder.users': '搜 anon_id 或 课程名…',
    'admin.search.placeholder.ingests': '搜 anon_id / 课程 / 错误码 / stage…',
    'admin.search.placeholder.repairs': '搜 anon_id 或 kind…',
    'admin.search.placeholder.feedback': '搜 anon_id / 课程 / item_id / 备注…',
    'admin.search.placeholder.events': '搜 anon_id / 课程 / summary / 视图…',
    'admin.stat.totalIngest': '总 ingest',
    'admin.stat.totalIngestSub': '24h: {count}',
    'admin.stat.totalCost': '总花费',
    'admin.stat.totalCostSub': '24h: ${cost}',
    'admin.stat.distinctUsers': '独立用户',
    'admin.stat.flagTotal': '🚩 flag 总数',
    'admin.stat.flagTotalSub': '24h: {count}',
    'admin.stat.avgRating': '⭐ 评分均值',
    'admin.stat.avgRatingSub': '{count} 条评分',
    'admin.stat.runtimeErrors': '运行时错误',
    'admin.stat.runtimeErrorsSub': '24h: {count}',
    'admin.col.type': '类型',
    'admin.col.count': '数量',
    'admin.col.field': '字段',
    'admin.col.itemCount': '条数',
    'admin.col.firstSample': '第 1 条样本',
    'admin.empty.noEvents': '无事件 — 朋友刷题 / flag / 触发错误后会出现',
    'admin.empty.noUsers': '无匹配用户',
    'admin.empty.noIngests': '无匹配 ingest',
    'admin.empty.noRepairs': '无 repair 记录',
    'admin.empty.noFeedback': '还没有 flag / 评分 / 备注。朋友在题目旁的 🏳 按钮提交后会出现在这里。',
    'admin.empty.noMatchingEvents': '无匹配事件',
    'admin.action.refresh': '↻ 刷新',
    'admin.action.localView': '本地视图',
    'admin.action.localViewTitle': '本地 IDB 视图（仅你浏览器）',
    'admin.action.downloadJson': '↓ 下载完整 JSON',
    'admin.action.expand': '展',
    'admin.action.collapse': '收',
    'admin.error.missingKey': 'Missing ?key= query parameter',
    'admin.error.unauthorized': 'Unauthorized (404 — wrong or missing key)',
    'admin.error.d1NotBound': 'D1 not bound on worker — run migrations first',
    'admin.notice.missingKey': '在 URL 中追加 <code>?key=&lt;ADMIN_KEY&gt;</code>',
    'admin.notice.errorPrefix': '错误：',
    'admin.notice.loading': '加载中…',
    'admin.section.eventTypeDistribution': '事件类型分布',
    'admin.section.recentIngests': '最近 {count} 条 ingest',
    'admin.tooltip.inferredErrorCode': '推断（worker finally 未执行 → checkpoint 老化推断）',
    'admin.ingestResult.parseFailed': 'result_json parse failed or empty',
    'admin.ingestResult.componentCounts': '各组件数量',
    'admin.ingestResult.fullJsonSummary': '完整 IngestPackage JSON ({kb} KB)',
    'admin.feedback.userNoteLabel': '用户备注：',
    'admin.feedback.viewAndUa': '视图: {view} · UA: {ua}',
    'admin.feedback.itemPreviewLabel': '题目内容片段：',
    'admin.events.filterAllTypes': '全部类型 ({count})',
    // ── Operator dashboard (19BM-D · /__operator DEV-only 工具页) ───────
    'operator.pageTitle': '操作者后台 · 反馈聚合',
    'operator.pageSubtitle': 'DEV-only · 跨课程汇总 itemFeedback · 用于排查 prompt 回归 / distractor 失败 / 渲染 bug',
    'operator.backToHome': '← 返回 home',
    'operator.tab.feedback': '反馈聚合 ({count})',
    'operator.tab.events': '事件日志 ({count})',
    'operator.stat.totalFlags': 'flag 总数',
    'operator.stat.totalRatings': '评分总数',
    'operator.stat.avgRating': '平均评分 (1–5)',
    'operator.stat.totalFeedback': '反馈条目总数',
    'operator.byCourse.title': '按课程分布',
    'operator.byCourse.empty': '暂无任何反馈条目。flag 一些 AI 内容来填充此页。',
    'operator.byCourse.colCourse': '课程',
    'operator.byCourse.colFlag': 'flag',
    'operator.byCourse.colRatingCount': '评分数',
    'operator.byCourse.colRatingAvg': '评分均值',
    'operator.items.title': '条目级反馈（按严重度排序）',
    'operator.items.empty': '无 flag / 评分。',
    'operator.items.colCourse': '课程',
    'operator.items.colType': '类型',
    'operator.items.colItemField': '条目 id · 字段',
    'operator.items.colFlag': 'flag',
    'operator.items.colRating': '评分',
    'operator.items.colUpdatedAt': '更新时间',
    'operator.items.colExpand': '展开',
    'operator.items.expand': '看',
    'operator.items.collapse': '收',
    'operator.items.noteLabel': '用户备注：',
    'operator.items.itemNotFound': '未找到对应 AI item — 可能已被删除或 key 解析失败。',
    'operator.events.filterType': '类型',
    'operator.events.filterAll': '全部 ({count})',
    'operator.events.actionRefresh': '刷新',
    'operator.events.actionClear': '清空',
    'operator.events.empty': '无事件 — 触发一些操作（flag / 编辑 / 触发错误）后会出现。',
    'operator.events.payloadLabel': 'payload',
    'operator.events.clearConfirm': '清空所有 event 记录？此操作不可逆。',
    'operator.events.clearConfirmAction': '清空',
    // ── Eval annotation page (19BM-D · /admin/eval 质量标注) ────────────
    'eval.title': '考完即弃 · 质量标注（v{version}）',
    'eval.header.submitted': ' · 已提交 {count}',
    'eval.header.alreadyAnnotated': '本项已标注',
    'eval.error.scoresIncomplete': '请为所有 4 个维度打分（0-3）后再提交',
    'eval.error.saveFailed': '保存失败: {message}',
    'eval.notice.needKey': '需要在 URL 中追加 <code>?key=&lt;ADMIN_KEY&gt;</code>',
    'eval.notice.needKeyPrefix': '需要在 URL 中追加 ',
    'eval.notice.needKeyCode': '?key=<ADMIN_KEY>',
    'eval.notice.needKeySuffix': '',
    'eval.notice.needPoolPrefix': '请在 URL 中提供 ',
    'eval.notice.needPoolCode': '?pool=<candidate-json-url>',
    'eval.notice.needPoolSuffix': '，例如：',
    'eval.notice.needPoolExample': '?key=K&pool=/docs/pools/sample-candidates.json&batch=exam-day2&seed=A&n=10',
    'eval.notice.poolLoadFailed': '候选池加载失败：{error}',
    'eval.notice.loading': '加载候选池中…',
    'eval.notice.poolEmpty': '候选池为空（pool URL 取回 0 项目）。检查 URL 与 JSON 顶层维度是否对齐。',
    'eval.notice.noMore': '没有更多项目了。共完成 {count} 项标注。',
    'eval.preview.missing': '（无 preview · 检查 candidate JSON 完整性）',
    'eval.button.prev': '← 上一题',
    'eval.button.submitNext': '提交并下一题',
    'eval.button.skip': '跳过 →',
    'eval.button.exportJson': '导出 JSON',
    'eval.button.exportCsv': '导出 CSV',
    'eval.button.import': '导入',
    'eval.progress.summary': '进度（{done} / {total}） · agreement: {agreement}',
    'eval.form.flagsLegend': 'flags · 可选',
    'eval.form.commentLegend': '评论 · 可选',
    'eval.form.commentPlaceholder': '写下让你打这个分的关键观察…',
    'eval.toast.importDone': '导入完成：{written} / {total} 条已存入 IDB',
    // ── 19BM-D Phase 5a 补缺：admin/eval/operator 接入真正缺的 key ──────────
    'admin.error.httpStatus': 'HTTP {status}',
    'admin.action.downloadCsv': '↓ CSV',
    'admin.action.viewJson': 'JSON',
    'admin.ingestResult.runIdLabel': 'runId:',
    'admin.ingestResult.lintReport': 'Lint report',
    'admin.ingestResult.routingDecisions': '路由决策 (P2-1)',
    'admin.feedback.payloadJsonLabel': 'payload JSON',
    'admin.feedback.itemIdLabel': 'item:',
    'eval.header.progress': ' · {done} / {total}',
    'eval.flagReasonLabel': 'flag:',
    'operator.locked.title': '本地操作者后台 · 已锁',
    'operator.locked.body1': '这是个 DEV-only 页面，prod 默认隐藏。要解锁，访问：',
    'operator.locked.body2Prefix': '解锁后此设备永久可见（写 localStorage）。如果你要的是 ',
    'operator.locked.body2Strong': '跨用户',
    'operator.locked.body2Suffix': ' 后台（朋友的 flag / 错误 / 花费），去 <code>/admin?key=ADMIN_KEY</code> — 那个走 D1 服务端，能看到所有人的数据。',
    // ── 19BM-D Phase 6a · Tier 1 复用组件 ──────────────────────────────────
    'common.edit': '编辑',
    // FlagButton
    'flag.ariaLabel': '标记或评分',
    'flag.titleActive': '已标记/评分',
    'flag.titleIdle': '标记或评分',
    'flag.categoryWrong': '这条内容有误 / 不准确',
    'flag.ratingLabel': '质量评分',
    'flag.starAria': '{count} 星',
    'flag.notePlaceholder': '备注（可选）— 哪里不对 / 怎样更好',
    'flag.repairTitle': '让 AI 针对你的反馈生成修复版本',
    'flag.repairAction': 'AI 修复',
    // RepairDialog
    'repair.needDetail': '请说明哪里不对，AI 才能针对性修复',
    'repair.budgetBlockedItem': '本条已用 {used} / 上限 {cap}，请手动编辑',
    'repair.budgetBlockedCourse': '本课程已用 {used} / 上限 {cap}，请手动编辑',
    'repair.applied': '已采用 AI 修复版本',
    'repair.keptOriginal': '已保留原版',
    'repair.ariaLabel': 'AI 修复',
    'repair.title': 'AI 修复',
    'repair.itemBudget': '本条已用 <code>{used}</code> / 上限 {cap}',
    'repair.courseBudget': '本课程 <code>{used}</code> / {cap}',
    'repair.hint': '告诉 AI 这条内容哪里有问题——越具体越好。AI 会保留题目 ID + 题干，仅修改有问题的部分。',
    'repair.placeholder': '例如：选项 B 太明显错（直接提到 Turing 而其它选项都没提）&#10;例如：解释长度不够，没说为什么 Case 2 适用&#10;例如：事实错误——不是 1997 年是 1998 年',
    'repair.submit': '让 AI 修复',
    'repair.loading': 'AI 正在修复中… (~3-8 秒)',
    'repair.llmFailedPrefix': 'LLM 调用失败：',
    'repair.schemaWarn': 'AI 输出未通过 schema 验证（仍可对照查看，不建议接受）',
    'repair.currentVersion': '当前版本',
    'repair.repairedVersion': 'AI 修复版本',
    'repair.keepOriginal': '保留原版',
    'repair.retryPhrase': '换个说法重试',
    'repair.schemaRetryTitle': '修复版本未通过 schema 验证，建议重试',
    'repair.accept': '采用 AI 版本',
    // EditableText
    'editableText.revert': '恢复 AI 原版',
    'editableText.revertConfirm': '确认恢复 AI 原版？你的修改会丢失。',
    'editableText.editedBadge': '已编辑',
    'editableText.statusPending': '编辑中…',
    'editableText.statusSaving': '保存中…',
    'editableText.statusSaved': '已保存',
    'editableText.statusError': '保存失败',
    // ChapterRegenButton
    'chapterRegen.disabledTitle': '本课程未启用可重新生成的模块',
    'chapterRegen.title': '重新生成本章节',
    'chapterRegen.ariaLabel': '重新生成本章节',
    'chapterRegen.modeGroup': '重新生成模式',
    'chapterRegen.loading': '重新生成中',
    'chapterRegen.hintPlaceholder': '对生成内容的要求…',
    // course-dashboard
    'dashboard.flaggedLabel': '本课程标记',
    // ── 19BM-D Phase 6b · Tier 2 复用组件 ──────────────────────────────────
    // CreateCourseForm
    'createCourse.fileTooLarge': '部分文件超过 50 MB 限制已跳过',
    'createCourse.totalTooLarge': '文件总大小不能超过 200 MB',
    'createCourse.nameLabel': '课程名称',
    'createCourse.namePlaceholder': '例如：国际商务',
    'createCourse.dateLabel': '考试日期',
    'createCourse.dateTbd': '日期待定',
    'createCourse.codeLabel': '课程代码',
    'createCourse.codePlaceholder': '选填，如 IIMT2641',
    'createCourse.optional': '选填',
    'createCourse.disciplineLabel': '学科领域',
    'createCourse.disciplineTemplates': '常用学科快捷选择',
    'createCourse.customDisciplinePlaceholder': '具体学科，如：法学 / 心理学 / 有机化学',
    'createCourse.customDisciplineHint': '填写具体学科可让 AI 更精准地匹配术语与出题风格（选填）',
    'createCourse.examTypeLabel': '考试类型',
    'createCourse.examTypePlaceholder': '不选则按通用风格生成',
    'createCourse.examTypeHint': '选择考试类型可让 AI 针对该场景调整术语精度与答题结构（选填 · 仅部分学科可选）',
    'createCourse.languageLabel': '内容语言',
    'createCourse.uploadLabel': '上传源材料',
    'createCourse.dropzone': '拖拽 PDF / PPTX / DOCX 到此处，或点击选择文件',
    'createCourse.uploadHint': '支持 PDF、PPTX、DOCX、MD、TXT · 单文件 ≤ 50 MB · 总计 ≤ 200 MB',
    'createCourse.aiHelp': 'AI 将根据你选择的学科与语言，结合材料内容生成题目、笔记与闪卡。上方标注的文件类型会帮助 AI 更准确地理解每份材料的用途。',
    'createCourse.creating': '正在创建…',
    'createCourse.submit': '创建课程并开始生成',
    // ErrorBoundary
    'errorBoundary.inlinePrefix': '这一段内容渲染失败：',
    'errorBoundary.pageBody': '这一页渲染时遇到问题。已记录到操作者后台 · 你可以刷新或回到首页继续。',
    'errorBoundary.retryPage': '重试本页',
    'errorBoundary.refreshApp': '刷新整个应用',
    'errorBoundary.home': '回首页',
    // RegenConfirmPanel
    'regenConfirm.apply': '确认应用',
    'regenConfirm.replaceSummary': '替换 {chapterScope}的 {existing} 项 → {items} 项',
    'regenConfirm.addSummary': '新增 {items} 项{chapterScope}',
    'regenConfirm.selected': '项已选',
    'regenConfirm.applyN': '应用 {count} 项',
    'regenConfirm.discardAll': '全部丢弃',
    // RegenPreview
    'regenPreview.confirmDelete': '确认删除',
    'regenPreview.confirmReplace': '确认替换',
    'regenPreview.confirmAdd': '确认新增',
    'regenPreview.badgeQuick': '⚡ 快速',
    'regenPreview.badgeDeep': '异步',
    'regenPreview.accept': '接受',
    'regenPreview.acceptN': '接受 ({count})',
    'regenPreview.discard': '丢弃',
    // LintSummary
    'lint.title': '质量审计',
    'lint.toggleShow': '隐藏明细',
    'lint.toggleHide': '查看明细 ({count})',
    'lint.suggestion': '建议:',
    'lint.severityCount': '· {error} 错 · {warn} 警告 · {info} 提示',
    'lint.severityError': '错',
    'lint.severityWarn': '警告',
    'lint.severityInfo': '提示',
    'lint.verdictHighConf': '质量良好',
    'lint.verdictLowConf': '质量待复核',
    'lint.verdictUnknown': '部分问题',
    'lint.kind.mcqDistractorBalance': 'MCQ 选项平衡',
    'lint.kind.difficultyDistribution': '难度分布',
    'lint.kind.cognitiveCoverage': 'Bloom 层级覆盖',
    'lint.kind.topicCoverage': 'Topic 覆盖率',
    'lint.kind.citationTrace': '事实溯源',
    'lint.kind.sourceRef': '结构化引用验证',
    'lint.kind.sharedConcepts': '共享概念覆盖',
    'lint.kind.optionParity': 'MCQ 长度公平',
    // MockPaperCreator
    'mockCreator.title': '新建模拟试卷',
    'mockCreator.nameLabel': '试卷名称',
    'mockCreator.scopeLabel': '章节范围（留空 = 全部）',
    'mockCreator.difficulty': '难度',
    'mockCreator.diffEasy': '简单',
    'mockCreator.diffMixed': '混合',
    'mockCreator.diffHard': '困难',
    'mockCreator.itemCounts': '题型数量',
    'mockCreator.generate': '生成 ({count} 题)',
    // relativeTime (提取自三份重复实现)
    'relativeTime.justNow': '刚刚',
    'relativeTime.secondsAgo': '{count}秒前',
    'relativeTime.minutesAgo': '{count}分钟前',
    'relativeTime.hoursAgo': '{count}小时前',
    'relativeTime.daysAgo': '{count}天前',
    'relativeTime.older': '{date}',
    // ── 19BM-D Phase 6c · Tier 3 view-local ────────────────────────────────
    // OutlineReviewView
    'outlineReview.title': '确认课程结构',
    'outlineReview.subtitle': 'AI 从「{course}」中识别了 {chapters} 个章节、{concepts} 个知识点',
    'outlineReview.note': '编辑章节名称、调整重要程度、或删除不需要的章节',
    'outlineReview.quickConfirm': '看起来不错，直接开始',
    'outlineReview.quickConfirmHint': '跳过编辑，使用 AI 提取的结构直接生成',
    'outlineReview.editConfirm': '确认并开始生成',
    'outlineReview.confirming': '正在开始…',
    'outlineReview.back': '返回',
    'outlineReview.chapter': '章节名称',
    'outlineReview.importance': '重要程度',
    'outlineReview.concepts': '知识点',
    'outlineReview.conceptsCount': '{count} 个知识点',
    'outlineReview.noteLabel': '补充说明（可选）',
    'outlineReview.notePlaceholder': '给 AI 的补充说明，如"重点考第三章"',
    'outlineReview.deleteLabel': '删除此章节',
    'outlineReview.deleteConfirm': '删除章节「{title}」？',
    'outlineReview.invalid': '⚠ 每章至少需要 1 个知识点',
    'outlineReview.feedback': '有问题？点击反馈',
    'outlineReview.feedbackSent': '已收到反馈，谢谢！',
    'outlineReview.advanced': '高级编辑',
    'outlineReview.advancedHint': '调整认知层级、生成配额等',
    'outlineReview.bloom': '认知层级侧重',
    'outlineReview.bloomDesc': '选择侧重哪些认知能力',
    'outlineReview.quota': '生成配额',
    'outlineReview.quotaDesc': '自定义每章生成题量',
    'outlineReview.mustCover': '必覆盖题型',
    'outlineReview.mustCoverDesc': '指定哪些题型必须覆盖此概念',
    'outlineReview.addConcept': '+ 添加知识点',
    'outlineReview.addConceptPlaceholder': '新知识点名称',
    'outlineReview.importance.overview': '需了解',
    'outlineReview.importance.overviewDesc': '了解即可，考试较少涉及',
    'outlineReview.importance.understand': '需掌握',
    'outlineReview.importance.understandDesc': '标准要求，需要理解掌握',
    'outlineReview.importance.keyTopic': '重点掌握',
    'outlineReview.importance.keyTopicDesc': '核心重点，考试高频出现',
    'outlineReview.step.upload': '上传资料',
    'outlineReview.step.review': '确认大纲',
    'outlineReview.step.generate': '生成内容',
    'outlineReview.step.study': '开始学习',
    'outlineReview.feedbackTitle': '反馈问题',
    'outlineReview.feedbackPlaceholder': '补充说明（可选）',
    'outlineReview.feedbackSubmit': '提交反馈',
    'outlineReview.feedbackMissingConcept': '知识点遗漏',
    'outlineReview.feedbackWrongStructure': '结构不准确',
    'outlineReview.feedbackWrongChapter': '章节划分有误',
    'outlineReview.feedbackOther': '其他问题',
    // outline-view
    'outlineView.chaptersCount': '个章节',
    'outlineView.qualityAudit': '质量审计',
    'outlineView.errorsCount': '错误',
    'outlineView.warningsCount': '警告',
    'outlineView.clean': '无问题',
    // outline-chapter-row
    'outlineChapter.aka': '别名: ',
    'outlineChapter.generatedItems': '已生成题目',
    'outlineChapter.noItems': '暂无题目',
    'outlineChapter.quotaAdjust': '配额调整',
    'outlineChapter.ok': '知道了',
    // mindmap-view
    'mindmap.zoomOut': '缩小 (- 键)',
    'mindmap.zoomIn': '放大 (+ 键)',
    'mindmap.fit': '适应屏幕 (F 键)',
    'mindmap.resetHint': '(0 键 / 双击画布)',
    'mindmap.helpBar': '点击节点折叠 / 展开 · 拖拽画布平移 · 滚轮 / 工具栏缩放 · 双击或按 0 重置',
    // mock-exam-phases
    'mockExam.subjectiveFree': '自由作答',
    'mockExam.subjectiveProof': '证明推导',
    'mockExam.subjectiveHint': '模考时仅展示题面，考试结束后到对应模块作答 + 自评。',
    'mockExam.subjectiveReviewHint': '完整作答与自评请到对应模块（{module}）。',
    // course-gate-components
    'gate.stepParsing': '正在解析上传的资料…',
    'gate.stepStructure': '正在分析课程结构…',
    'gate.stepOutline': '正在生成课程大纲…',
    // course-shell
    'nav.sidebarToggleClose': '关闭菜单',
    'nav.sidebarToggleOpen': '打开菜单',
    // history-view
    'history.coursesCount': '门课程',
    'history.clean': '干净',
    // home
    'home.operatorLinkTitle': 'DEV-only · 本地 IDB',
    'home.operatorLinkText': 'dev · operator (local)',
    'home.countdownDays': '{n} 天后',
    'home.countdownToday': '今天考试',
    'home.countdownPast': '已结束',
    'home.sealAlt': '考印',
    // quiz-phases
    'quiz.editOptionsFlag': '编辑选项 · flag',
    'quiz.wholeItemFlag': '整体题目 flag / rating · AI 修复',
    'quiz.tfShortcuts': 'T/1 = 正确 · F/2 = 错误 · B = 收藏',
    // wrong-answers-view
    'wrongAnswers.avgScore': ' · 平均 {avg}/3',
    // mermaid-block
    'mermaid.renderFailed': '⚠ mermaid 渲染失败：',
    // idb-health-watcher
    'idbHealth.unavailable': '本地存储不可用 — 当前会话进度不会保存（隐私模式 / 浏览器存储被禁用）',
    // ChapterCard
    'chapterCard.stageMcqs': '选择题',
    'chapterCard.stageFlashcards': '闪卡',
    // 19BO+ Line 2 B3.4 · evaluate dialog + verdict card
    'evaluate.title': 'AI 评分',
    'evaluate.ariaLabel': 'AI 评分对话框',
    'evaluate.costHint': '消耗约 3 点 · 返回分数 + 评分维度反馈',
    'evaluate.confirm': '评分',
    'evaluate.loading': '评分中…',
    'evaluate.reviewHint': 'AI 评分结果 · 确认后保存',
    'evaluate.accept': '保存评分',
    'evaluate.cancel': '取消',
    'evaluate.retry': '重试',
    'evaluate.rescore': '重新评分',
    'evaluate.scoreLabel': '分数',
    'evaluate.rubricLabel': '评分维度',
    'evaluate.feedbackLabel': '反馈',
    // 19BO+ Line 2 B4.3 · diagnose dialog + verdict card（对齐 evaluate 命名）
    'diagnose.title': 'AI 弱项诊断',
    'diagnose.ariaLabel': 'AI 诊断对话框',
    'diagnose.costHint': '消耗约 3 点 · 分析你的错题并给出优先级弱点',
    'diagnose.confirm': '诊断我的弱项',
    'diagnose.loading': '诊断中…',
    'diagnose.reviewHint': 'AI 诊断结果 · 确认后保存',
    'diagnose.accept': '保存诊断',
    'diagnose.cancel': '取消',
    'diagnose.retry': '重试',
    'diagnose.weaknessesLabel': '弱点',
    'diagnose.severityHigh': '高',
    'diagnose.severityMedium': '中',
    'diagnose.severityLow': '低',
    'diagnose.summaryLabel': '总体总结',
    'diagnose.practiceLabel': '补练建议',
    'diagnose.statsBasisLabel': '基于 {total} 道错题',
    // ── B5 桥5 · 后台自动诊断 ───────────────────────────────────────────
    'diagnose.autoNotifTitle': '诊断完成，待你查看',
    'diagnose.autoNotifMessage': '后台刚刚完成一次弱项诊断，去 dashboard 查看结果。',
    'diagnose.autoNotifView': '去查看',
    'diagnose.autoEnableLabel': '后台自动诊断',
    'diagnose.autoEnableHelp': '开启后，学习期间应用会在后台定期运行 AI 弱项诊断。结果需你确认后才会生效——未经确认不会自动应用。',
    'diagnose.autoIntervalLabel': '检查频率',
    'diagnose.autoInterval6h': '每 6 小时',
    'diagnose.autoInterval12h': '每 12 小时',
    'diagnose.autoInterval24h': '每 24 小时',
    'diagnose.autoCostHint': '每次诊断约消耗 3 点。余额不足时自动诊断会被静默跳过。',
    'diagnose.pendingTitle': '新诊断待你查看',
    'diagnose.pendingHelp': '这是后台自动诊断产出的结果。确认后将成为你的当前诊断，或丢弃。',
    'diagnose.pendingQueuedAgo': '{ago} 产出',
    'diagnose.pendingAccept': '确认采用为当前诊断',
    'diagnose.pendingReject': '丢弃',
    // ── B5 桥5 · quiz 完成态补练推荐块 ───────────────────────────────────
    'quiz.recommendPractice': '针对你的弱点补练',
    'quiz.recommendPracticeHint': '根据你最近的诊断结果，为本次测验涉及的弱点生成针对性练习题。',
    'quiz.recommendGenerate': '生成练习题',
    // ── B5.4 · 跨设备同步 UX（sync-status-chip + opt-in panel + hydration toast）──
    'sync.sectionTitle': '学习数据云同步',
    'sync.toggleLabel': '跨设备同步学习进度',
    'sync.toggleHint': '开启后，错题 / 复习 / 测验记录等学习数据将同步到云端，可在其他设备访问。关闭时仅保存在本机。',
    'sync.fieldsTitle': '同步内容',
    'sync.fieldsCloudDesc': '云同步：错题、间隔复习状态、测验记录、收藏、论述与简答题草稿。',
    'sync.fieldsLocalDesc': '仅本机：单题编辑、反馈、修复（设备私有）。',
    'sync.statusIdle': '已同步',
    'sync.statusPending': '待同步 · {count}',
    'sync.statusSaving': '同步中…',
    'sync.statusSaved': '已同步',
    'sync.statusError': '同步失败',
    'sync.statusOffline': '离线',
    'sync.pendingCount': '待同步 {count} 条',
    'sync.lastSyncedAt': '上次同步 {time}',
    'sync.hydrated': '从云端同步了 {count} 条记录',
};
//# sourceMappingURL=zh.js.map